import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialHrecState: Dtos.Hrec & IRegistrationFormState = {
    id: null,
    hrecNo: null,
    fullName: null,
    shortName: null,
    website: null,
    entityName: null,
    chair: null,
    administratorId: null,
    administrator: null,
    mutualAcceptanceReview: null,
    nhmrcCertificate: null,
    comments: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    trialInstitutions: []
}

export interface IHrecReduxFormState {
    id: IFieldState<number>,
    hrecNo: IFieldState<string>,
    fullName: IFieldState<string>,
    shortName: IFieldState<string>,
    website: IFieldState<string>,
    entityName: IFieldState<string>,
    chair: IFieldState<string>,
    administratorId: IFieldState<number>,
    mutualAcceptanceReview: IFieldState<number>,
    nhmrcCertificate: IFieldState<number>,
    comments: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
